import './Brands.css';
import emaar from '../../assets/emaar.png';
import pullman from '../../assets/pullman.png';
import starco from '../../assets/starco.png';
import abc from '../../assets/abc.png';
import uss from '../../assets/uss.png';
import arada from '../../assets/arada.png';

const partners = [
  { src: arada, alt: "Arada" },
  { src: emaar, alt: "Emaar" },
  { src: pullman, alt: "Pullman" },
  { src: starco, alt: "Starco" },
  { src: abc, alt: "ABC" },
  { src: uss, alt: "USS" },
];

function Brands() {
  return (
    <div id="brands">
      <div className="brands-overlay"></div>
      <div className="brands-container">
        <h1>Our Partners</h1>
        <p className="brands-subtitle">Trusted Collaborations</p>
        <p className="brands-description">
          Partnering with strategic groups that offer solid presence
          and shared vision for excellence.
        </p>
        <div className="brands">
          {partners.map((partner, index) => (
            <div className="brand-item" key={index}>
              <img src={partner.src} alt={partner.alt} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Brands;
